import routerOptions0 from "/data/www/batobs.org/vleermuisvang-db/nuxt/node_modules/.pnpm/nuxt@3.5.3_@types+node@20.3.0_eslint@8.42.0_stylelint@15.10.3_typescript@5.1.3/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}